/*
 * @Description:
 * @Author: Luke Z
 * @Date: 2021-03-11 11:27:51
 * @LastEditors: Luke Z
 * @LastEditTime: 2021-07-12 19:01:30
 * @FilePath: /unifyxp-v2-store-portal/src/pages/SalesChannelContentEditor/SalesChannelEditorMaintenancePage/common.ts
 */
import { generateCollapse } from 'src/constrains/SalesChannelPreviewPageComponents/tools';
import {
  //generateResponsiveImage,
  generateResponsiveTextContent,
} from 'src/constrains/DraggableModules/tools';

export enum EnumCollapseId {
  longCanvas = 'longCanvas',
  text = 'text',
}

export const fixedCollapse = [EnumCollapseId.longCanvas, EnumCollapseId.text];

export const defaultCollapse = (display?) => {
  return generateCollapse(fixedCollapse, display);
};

export const generateDefaultText = () => {
  return generateResponsiveTextContent();
};

export const generateDefaultLongCanvas = () => {
  return {
    longCanvas: [],
  };
};
